//Node modules

import { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'

function Navbar({ navOpen }) {
  const lastActiveLink = useRef()

  const activeBox = useRef()

  const initActiveBox = () => {
    if (!activeBox.current || !lastActiveLink.current) return
    activeBox.current.style.top = lastActiveLink.current.offsetTop + 'px'
    activeBox.current.style.left = lastActiveLink.current.offsetLeft + 'px'
    activeBox.current.style.width = lastActiveLink.current.offsetWidth + 'px'
    activeBox.current.style.height = lastActiveLink.current.offsetHeight + 'px'
  }

  useEffect(() => {
    initActiveBox()
    window.addEventListener('resize', initActiveBox)
    return () => window.removeEventListener('resize', initActiveBox)
  }, [])

  const activeCurrentLink = (event) => {
    lastActiveLink.current?.classList.remove('active')
    event.target.classList.add('active')
    lastActiveLink.current = event.target

    initActiveBox()
  }

  const navItems = [
    {
      label: 'Home',
      link: '#home',
      className: 'nav-link active',
      ref: lastActiveLink,
    },
    {
      label: 'About',
      link: '#about',
      className: 'nav-link',
    },
    {
      label: 'Education',
      link: '#education',
      className: 'nav-link',
    },
    {
      label: 'Experience',
      link: '#experience',
      className: 'nav-link',
    },
    {
      label: 'Tools',
      link: '#tools',
      className: 'nav-link',
    },
    {
      label: 'Projects',
      link: '#projects',
      className: 'nav-link',
    },
  ]
  return (
    <nav className={'navbar ' + (navOpen ? 'active' : '')}>
      {navItems.map(({ label, link, className, ref }, key) => (
        <a
          href={link}
          key={key}
          ref={ref}
          className={className}
          onClick={activeCurrentLink}
        >
          {label}
        </a>
      ))}
      <div className="active-box" ref={activeBox}></div>
    </nav>
  )
}

Navbar.propTypes = {
  navOpen: PropTypes.bool.isRequired,
}

export default Navbar
